
<div v-click-outside="() => isMobile() ? null :toggle(false)">
  <button 
    :class="['get-quote-button border rounded-full py-2 px-1 text-white font-semibold flex items-center justify-center', { 'mobile-h' : isMobile() } ]" 
    @click="toggle()">
    View Quote
  </button>
  <div v-if="showSummary" class="quote-summary-dropdown">
    <quote-summary @hide="toggle(false)" />
  </div>
</div>
